import { IButtonStyles } from '@fluentui/react';
import {
  concatStyleSets,
  getHighContrastNoAdjustStyle,
  HighContrastSelector,
  ITheme,
} from '@fluentui/react/lib/Styling';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import { commonHighContrastOutlineHoverFocus, getHighContrastAutoAdjustStyle } from '@1js/acui-common';
import { AppGalleryStyles } from '@1js/acui-gallery';

const galleryButtonClassname = 'galleryButton';
const galleryButtonOffset = 4;
const galleryPaddingLeft = 8;
const galleryItemWidth = 108;
const borderWidth = 4;
export const inkThicknessGalleryButtonWidth = galleryItemWidth + galleryPaddingLeft + borderWidth * 2;

const highContrastLabel = {
  [HighContrastSelector]: {
    borderColor: 'transparent',
    color: 'ButtonText',
    backgroundColor: 'ButtonFace',
    ...getHighContrastNoAdjustStyle(),
  },
};

const getCommonInkThicknessGalleryButtonStyles = memoizeFunction(
  (): IButtonStyles => {
    return {
      root: [
        galleryButtonClassname,
        {
          boxSizing: 'content-box',
          height: 28,
          padding: '0px 0px 0px 8px',
          borderWidth: galleryButtonOffset,
          textAlign: 'left',
          selectors: {
            [HighContrastSelector]: {
              borderColor: 'transparent',
            },
          },
        },
      ],
      flexContainer: {
        justifyContent: 'flex-start',
        ...getHighContrastAutoAdjustStyle(),
      },
      label: {
        width: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        display: 'block',
        textOverflow: 'ellipsis',

        // Without line-height normal, the text disappears in IE 11.
        lineHeight: 'normal',
        selectors: {
          ...highContrastLabel,
        },
      },
    };
  }
);

const getExpandedButtonHighContrastStyles = {
  selectors: {
    [HighContrastSelector]: {
      borderColor: 'Highlight',
      backgroundColor: 'transparent',
      outlineColor: 'ButtonText',
      ...getHighContrastNoAdjustStyle(),
    },
  },
};

const getExpandButtonStyles: IButtonStyles = {
  root: {
    width: galleryItemWidth,
    borderWidth: galleryButtonOffset,
    selectors: {
      ':focus': {
        borderWidth: galleryButtonOffset,
      },
    },
  },
  rootChecked: [
    {
      borderWidth: galleryButtonOffset,
      selectors: {
        ':focus': [commonHighContrastOutlineHoverFocus, getExpandedButtonHighContrastStyles],
      },
    },
    getExpandedButtonHighContrastStyles,
  ],
  rootFocused: getExpandedButtonHighContrastStyles,
  rootPressed: getExpandedButtonHighContrastStyles,
  rootHovered: [commonHighContrastOutlineHoverFocus, getExpandedButtonHighContrastStyles],
  rootCheckedHovered: [commonHighContrastOutlineHoverFocus, getExpandedButtonHighContrastStyles],
};

export const getInkThicknessGalleryStyles = memoizeFunction(
  (_theme: ITheme, customStyles?: Partial<AppGalleryStyles>): Partial<AppGalleryStyles> => {
    return {
      ...customStyles,
      galleryContainer: customStyles && customStyles.galleryContainer,
      galleryButtonInPreview: concatStyleSets(
        getCommonInkThicknessGalleryButtonStyles(),
        customStyles && customStyles.galleryButtonInPreview
      ),
      galleryButtonInExpanded: concatStyleSets(
        getCommonInkThicknessGalleryButtonStyles(),
        getExpandButtonStyles,
        customStyles && customStyles.galleryButtonInExpanded
      ),
    };
  }
);
